import * as React from 'react';
import { SVGProps } from 'react';

const IcPhotocamera = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
      transform="translate(4 6)"
    >
      <path d="M24 19.636H0V3.273h6.545L8.727 0h6.546l2.182 3.273H24v16.363Z" />
      <circle cx={12} cy={10.909} r={4.364} strokeLinejoin="round" />
    </g>
  </svg>
);
export default IcPhotocamera;
